export default __webpack_public_path__ + "static/media/slider2.cf3dd4fa.png";